import React, { useState, useEffect, useRef } from "react";
import { useHistory , useLocation } from "react-router-dom";
import { useTheme } from "@repo/shared";
import { confirmAlert } from 'react-confirm-alert'; // Import
import queryString from 'query-string';
import { Container, Row, Col, Card, Button, Dropdown, DropdownButton } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEnvelope, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import NoData from '../common/NoData';
import LoadingSpinner from '../common/LoadingSpinner';
import EventDataService from "../../services/event/EventService";
import ConfigDataService from "../../services/config/ConfigService";
import StudentDataService from "../../services/student/StudentService";
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import SortCaret from '../common/SortCaret';
import { ButtonAwaiting } from '../common/Buttons';
import MySelectFilter from '../common/MySelectFilter';
import { useAcademicYear } from "../../contexts/AcademicYearContext";

const PAID_EMAIL_BODY = `Hello
Thanks for paying!
Goodbye.`

const StudentsList = (props) => {
  const history = useHistory();
  const { appTheme } = useTheme();
  const [students, setStudents] = useState([]);
  const [allSemesterDates, setAllSemesterDates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedYear, setSelectedYear] = useState();
  const [filters, setFilters] = useState({});
  const [unpaidEmailBody, setUnpaidEmailBody] = useState();
  const [unpaidSpecialEventEmailBody, setUnpaidSpecialEventEmailBody] = useState();
  const [sendingEmailStudentId, setSendingEmailStudentId] = useState(null);
  const [filteredRowCount, setFilteredRowCount] = useState(0);
  const [schoolNameFilter, setSchoolNameFilter] = useState({});
  const studentsRef = useRef();
  const search = useLocation().search;
  const { activeYear, activeSemester } = useAcademicYear();

  const UNPAID_EMAIL_SUBJECT = `${appTheme?.appName || ''} - Unpaid`;
  const PAID_EMAIL_SUBJECT = `${appTheme?.appName || ''} - Paid`;

  studentsRef.current = students;

  useEffect(() => {

    document.title = `${appTheme?.appName || ''} - Students`

    const bg = async () => {
      const incomingAllSemesterDates = await ConfigDataService.getSemesterDates();
      setAllSemesterDates(incomingAllSemesterDates);

      const incomingUnpaidEmailBody = await ConfigDataService.getUnpaidEmailBody();
      setUnpaidEmailBody(incomingUnpaidEmailBody);

      const incomingUnpaidSpecialEventEmailBody = await ConfigDataService.getUnpaidSpecialEventEmailBody();
      console.log('sopecial event emaio', incomingUnpaidSpecialEventEmailBody);
      setUnpaidSpecialEventEmailBody(incomingUnpaidSpecialEventEmailBody);

      const schoolName = new URLSearchParams(search).get('schoolName');
      const emailAddress = new URLSearchParams(search).get('emailAddress');
      const schoolYear = new URLSearchParams(search).get('schoolYear');
      console.log('schoolName', schoolName);

      const f = {};
      if (schoolName) f['schoolName'] = schoolName;
      if (emailAddress) f['emailAddress'] = emailAddress;
      if (schoolYear) {
        setSelectedYear(schoolYear);
      } else {
        setSelectedYear(activeYear?.year);
      }
      setFilters(f);
    }
    bg();

  }, []);

  useEffect(() => {
    if (!selectedYear) return;

    setLoading(true);
    setStudents([]);
    const bg = async () => {
      try {
        const newStudents = await StudentDataService.getByEnrolmentYear(selectedYear);

        const p = newStudents.map(s => {
          const classSemesters = s.classSemesters ? s.classSemesters.split(',').sort((a, b) => b.localeCompare(a)).join(',') : '';
          s.classSemesters = classSemesters;
          console.log('classSemesters', classSemesters);
          return s;
        })
        setStudents(newStudents);
        setFilteredRowCount(newStudents.length);

        const schools = newStudents
          .map(s => s.schoolName)
          .filter((name, index, arr) => name && arr.indexOf(name) === index)
          .sort()
          .reduce((acc, name) => ({ ...acc, [name]: name }), {});

        setSchoolNameFilter(schools);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
    bg();

  }, [selectedYear]);

  const addStudent = () => {
    history.push("student/");
  }
  const openStudent = (row) => {
    history.push("student/" + row.original.id);
  };

  const sendPaidEmailForEvent = async ({ paid, specialEvent }) => {
    setSendingEmailStudentId('_event_' + specialEvent.id);
    try {
      const studentsForEvent = await StudentDataService.getAllForEvent(specialEvent.id);

      console.log('students for event', studentsForEvent);

      const emailAddresses = studentsForEvent.filter(s => {
        if (paid) {
          return s.paidTimestamp;
        } else {
          return !s.paidTimestamp
        }
      }).map(s => s.emailAddress);

      const mailTo = `mailto:?bcc=${emailAddresses.join(',')}&body=${encodeURIComponent(paid ? PAID_EMAIL_BODY : unpaidSpecialEventEmailBody)}&subject=${paid ? PAID_EMAIL_SUBJECT : UNPAID_EMAIL_SUBJECT}`
      window.location.href = mailTo;
      setSendingEmailStudentId(null);
    } catch (error) {
      console.error('Error sending email:', error);
      setSendingEmailStudentId(null);
    }
  }

  const sendPaidEmail = async ({ students, paid }) => {
    setSendingEmailStudentId('_paid_' + paid);
    try {
      if (selectedYear === 'special') {
        const events = await EventDataService.getAll();

        const buttons = events.map(specialEvent => {
          return {
            label: specialEvent.title,
            onClick: () => {
              sendPaidEmailForEvent({ students, paid, specialEvent });
            }
          }
        })

        confirmAlert({
          title: 'Which Special Event',
          message: `For which Special Event would you like to send the email?`,
          afterClose: () => {
            setSendingEmailStudentId(null);
          },
          buttons
        });
        setSendingEmailStudentId(null);
      } else {
        confirmAlert({
          title: 'Which Semester',
          message: `For which semester would you like to send the email?`,
          afterClose: () => {
            setSendingEmailStudentId(null);
          },
          buttons: [
            {
              label: 'Winter',
              onClick: () => {
                const emailAddresses = getEmailAddresses({ students, paid, semester: 'winter' });
                const mailTo = `mailto:?bcc=${emailAddresses.join(',')}&body=${encodeURIComponent(paid ? PAID_EMAIL_BODY : unpaidEmailBody)}&subject=${paid ? PAID_EMAIL_SUBJECT : UNPAID_EMAIL_SUBJECT}`
                window.location.href = mailTo;
                setSendingEmailStudentId(null);
              }
            },
            {
              label: 'Summer',
              onClick: () => {
                const emailAddresses = getEmailAddresses({ students, paid, semester: 'summer' });
                const mailTo = `mailto:?bcc=${emailAddresses.join(',')}&body=${encodeURIComponent(paid ? PAID_EMAIL_BODY : unpaidEmailBody)}&subject=${paid ? PAID_EMAIL_SUBJECT : UNPAID_EMAIL_SUBJECT}`
                window.location.href = mailTo;
                setSendingEmailStudentId(null);
              }
            },
          ]
        });
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setSendingEmailStudentId(null);
    }
  };

  const getEmailAddresses = ({ students, paid, semester }) => {
    const filteredStudents = students.filter(s => {
      if (paid) {
        return semester === 'winter' ? s.paidTimestampWinter : s.paidTimestampSummer;
      } else {
        //for unpaids, first need to check that they are assigned to classes
        return semester === 'winter'
          ? (!s.paidTimestampWinter && s.classSemesters.includes('inter'))
          : (!s.paidTimestampSummer && s.classSemesters.includes('ummer'))
      }
    });

    console.log(filteredStudents);
    return filteredStudents.map(s => s.emailAddress);
  }

  const studentColumns = [
    { sort: true, dataField: 'firstName', text: 'First Name', filter: textFilter(), sortCaret: SortCaret },
    { sort: true, dataField: 'lastName', text: 'Last Name', filter: textFilter(), sortCaret: SortCaret },
    {
      sort: true, dataField: 'paid', text: 'Paid', filter: textFilter(), sortCaret: SortCaret,
      formatter: (cell, row) => (
        row.paidTimestampWinter ? "Yes" : "No") + ',' + (row.paidTimestampSummer ? "Yes" : "No"
        )
    },
    { sort: true, dataField: 'emailAddress', text: 'Parent Email', filter: textFilter({ defaultValue: filters['emailAddress'] || '' }), sortCaret: SortCaret },
    {
      sort: true,
      dataField: 'schoolName',
      text: 'School',
      filter: customFilter(),
      filterRenderer: (onFilter, column) => (
        <MySelectFilter
          onFilter={onFilter}
          column={column}
          options={schoolNameFilter || {}}
          defaultValue={new URLSearchParams(search).get('schoolName') || ''}
          placeholder={`Select ${column.text}...`}
          fieldName="schoolName"
          history={history}
          search={search}
        />
      ),
      sortCaret: SortCaret
    },
    { sort: true, dataField: 'year', text: 'Year', filter: textFilter(), sortCaret: SortCaret },
    { sort: true, dataField: 'className', text: 'Class', filter: textFilter(), sortCaret: SortCaret },
  ];

  const tableNoDataIndication = () => {
    if (loading) return <div className="p-4"><LoadingSpinner /></div>;
    return <NoData type="students" />;
  };

  function afterFilter(newResult, newFilters) {
    setFilteredRowCount(newResult.length);
  }

  return (
    <Container className="py-2 py-lg-4">
      <Row className="justify-content-center">
        <Col>
          <Card className="h-100 shadow-sm">
            <Card.Header className="d-flex flex-column gap-2">
              <div className="d-flex align-items-center gap-2">
                <h2 className="mb-0">Students  ({selectedYear})</h2>
                {/* Desktop button layout */}
                <div className="d-none d-md-flex gap-2 ms-auto">
                  <ButtonAwaiting
                    disabled={selectedYear === 'none' || sendingEmailStudentId !== null}
                    isPrimary={false}
                    isAwaiting={sendingEmailStudentId === '_paid_false'}
                    title="Email Unpaid"
                    icon={<FontAwesomeIcon icon={faEnvelope} className="me-2" />}
                    awaitingTitle="Sending..."
                    type="button"
                    onClick={async (e) => {
                      e.stopPropagation();
                      sendPaidEmail({ students, paid: false })
                    }} />
                  <ButtonAwaiting
                    disabled={selectedYear === 'none' || sendingEmailStudentId !== null}
                    isPrimary={false}
                    isAwaiting={sendingEmailStudentId === '_paid_true'}
                    title="Email Paid"
                    icon={<FontAwesomeIcon icon={faEnvelope} className="me-2" />}
                    awaitingTitle="Sending..."
                    type="button"
                    onClick={async (e) => {
                      e.stopPropagation();
                      sendPaidEmail({ students, paid: true })
                    }} />
                  <Button variant="primary" size="sm" onClick={addStudent}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Add Student
                  </Button>
                </div>
                {/* Mobile dropdown menu */}
                <div className="d-md-none ms-auto">
                  <DropdownButton
                    id="student-actions-dropdown"
                    title={<FontAwesomeIcon icon={faEllipsisV} />}
                    variant="secondary"
                    size="sm"
                    align="end"
                  >
                    <Dropdown.Item
                      onClick={(e) => {
                        e.stopPropagation();
                        sendPaidEmail({ students, paid: false })
                      }}
                      disabled={selectedYear === 'none' || sendingEmailStudentId !== null}
                    >
                      Email Unpaid
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={(e) => {
                        e.stopPropagation();
                        sendPaidEmail({ students, paid: true })
                      }}
                      disabled={selectedYear === 'none' || sendingEmailStudentId !== null}
                    >
                      Email Paid
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={addStudent}>
                      Add Student
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                Showing <strong>{filteredRowCount}</strong> of <strong>{students.length}</strong> students.
              </div>
            </Card.Header>
            <Card.Body className="p-0" style={{ overflowX: 'auto' }}>
              <div className="p-3" style={{ display: 'flex', alignItems: 'flex-end', gap: '1rem' }}>
                <div>
                  <label htmlFor="year" style={{ marginBottom: '0.25rem', display: 'block', fontSize: '0.875rem' }}>Enrolment</label>
                  <select
                    className="form-select"
                    id="selectedYear"
                    name="selectedYear"
                    value={selectedYear}
                    onChange={(e) => {
                      setSelectedYear(e.target.value)

                      const parsed = queryString.parse(history.location.search);

                      //set new value
                      parsed['schoolYear'] = e.target.value;
                      const qs = Object.keys(parsed).map(k => {
                        return `${k}=${parsed[k]}`
                      }).join('&');


                      history.push({
                        pathname: `/students`,
                        search: `?${qs}`//`?${id}=${e.target.value}`
                      })

                    }
                    }>
                    {allSemesterDates.map((sd) => <option key={sd.year} value={sd.year}>{sd.year}</option>)}
                    <option key='none' value='none'>Not Enrolled</option>
                    <option key='special' value='special'>Enrolled in a Special Event</option>
                  </select>
                </div>
              </div>
              {/* Student Table.  if the current semester is Winter and If the student classCount is 0 then render the row with a red highlight.  
                  If the current semester is summer and the classCount is 1 then render the row with a red highlight
                  The highlight needs to be a bit more subtle than 'table-danger'*/}

              <BootstrapTable
                keyField='id'
                rowClasses={(row) => (!row.classSemesters.includes(activeSemester )) ? 'table-warning' : ''}
                striped
                hover
                condensed
                data={students}
                columns={studentColumns}
                bordered={false}
                classes="mb-0"
                noDataIndication={tableNoDataIndication}
                filter={filterFactory({ afterFilter })}
                rowEvents={{ onClick: (e, row) => openStudent({ original: row }) }}
              />
            </Card.Body>
            <Card.Footer className="text-muted">
              Showing <strong>{filteredRowCount}</strong> of <strong>{students.length}</strong> students.
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );

};

export default StudentsList;